import { getUserAvailableBonuses, getUserBonusHistory } from "@actions/bonus";
import Loading from "@components/loading/index.jsx";
import PaginationWrapper from "@pages/profile-v2/pages/bonuses/containers/Pending/Pagination";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import NoContent from "../../../history-v2/components/NoContent";
import { BonusWrapper } from "../../elements";
import { isExpired, isOverLimit } from "../Active/helpers";
import BonusItem from "./BonusItem";

const ExpiredBonus = ({
	getUserBonusHistory,
	getUserAvailableBonuses,
	bonusList,
	offsetToken,
	translate,
}) => {
	const rootRef = useRef(null);
	const [page, setPage] = useState(0);
	const [openIndex, setOpenIndex] = useState(-1);
	const [loading, setLoading] = useState(false);
	const [expiredBonuses, setExpiredBonuses] = useState([]);

	const onPaginate = (page, cb) => {
		if (offsetToken === undefined || !!offsetToken) {
			setLoading(true);
			getUserBonusHistory(
				{ params: { size: 50, lastItem: offsetToken, type: "BonusDeposit" } },
				() => {
					setLoading(false);
					cb();
				}
			);
			setPage(page);
		}
	};

	useEffect(() => {
		setLoading(true);
		getUserBonusHistory({ params: { size: 50, type: "BonusDeposit" } }, () => {
			setLoading(false);
		});

		fetchExpiredBonuses();
	}, []);

	const fetchExpiredBonuses = () => {
		getUserAvailableBonuses({ params: { size: 25 } }, (response) => {
			if (response?.bonusClaims) {
				const now = moment();
				const expired = response.bonusClaims.filter((b) => {
					const endDate = moment(Number(b?.timestamp)).add(
						b?.bonusDetail?.claimExpirationDays,
						"days"
					);

					return endDate.isBefore(now);
				});

				setExpiredBonuses(expired);
			}
		});
	};

	const filteredBonusList = [
		...(bonusList
			? bonusList.filter(
					(item) =>
						item.bonus &&
						item.bonus.instruction.type !== "Freespin" &&
						item.walletContributions[0].wageringRatio !== 100 &&
						(isExpired(item) || isOverLimit(item))
				)
			: []),
		...expiredBonuses.map((bonus) => ({ ...bonus, isPendingItem: true })),
	];

	return loading ? (
		<Loading loading={loading} />
	) : filteredBonusList?.length === 0 ? (
		<NoContent
			translate={translate}
			title={"NoInfoText"}
			description={"NoInfoBonus"}
			noBackground={true}
		/>
	) : (
		<div
			style={{ width: "100%" }}
			ref={rootRef}>
			<PaginationWrapper
				initialBind={true}
				page={page}
				root={rootRef}
				onPaginate={onPaginate}>
				<BonusWrapper>
					{filteredBonusList.map((item, index) => (
						<BonusItem
							key={item.transactionId || index}
							data={item}
							index={index}
							translate={translate}
							openIndex={openIndex}
							setOpenIndex={setOpenIndex}
							isOverLimit={isOverLimit(item)}
							isExpired={isExpired(item)}
							isPendingItem={item.isPendingItem || false}
						/>
					))}
				</BonusWrapper>
			</PaginationWrapper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	bonusList: state.bonus.bonusHistory.reports,
	offsetToken: state.bonus.bonusHistory.offset,
});

const mapDispatchToProps = {
	getUserBonusHistory,
	getUserAvailableBonuses,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredBonus);
